import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  propertyAmenities: [],
  addAmenitiesData: [],
  allPropertyAmenities: []
};

export const PropertyAmenitiesSlice = createSlice({
  name: "propertyAmenities",
  initialState,
  reducers: {
    getAllPropertyAmenitiesAction: (state, action) => {
      state.allPropertyAmenities = action.payload;
    },
    getSinglePropertyAmenitiesAction: (state, action) => {
      state.propertyAmenities = action.payload;
    },
    getAddAmenitiesDataAction: (state, action) => {
      state.addAmenitiesData = action.payload;
    },
  },
});

export default PropertyAmenitiesSlice.reducer;

export const { getAllPropertyAmenitiesAction, getSinglePropertyAmenitiesAction, getAddAmenitiesDataAction } = PropertyAmenitiesSlice.actions;
